module.exports = __webpack_public_path__ + "static/media/horizontalRectangle_salmon.37b5f0bb.svg";